import React, {useState, useContext, useEffect , useRef } from 'react';
import { useHistory  } from "react-router-dom";
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';
import Context from '../../context/context';
import Orbit from './steps/orbit';
import {travelTypeEnum, sideEnum, travelTypeAdminEnum} from '../../common/enum';
import DateHour from './steps/date-hour/index';
import TravelType from './steps/travelType/index';
import CarType from './steps/car-type/index';
import PassengerDetails from './steps/passenger-details/index';
import Notes from './steps/notes/index';
import Email from './steps/email/index';
import Summary from './steps/summary/index';
import SignatureCanvas from 'react-signature-canvas';
import { fetchSaveTravel, fetchOrbits, fetchStopOptionsData, fetchStartLocationOptionsData,
fetchCarsOptionsData  , fetchPaymentDetails , fetchDollarValue , fetchAllNewYearOrbits , fetchTermsValue, 
fetchCustomerSettings, fetchAirportsAndHours,
fetchRange2025 , fetchTrainsOrbits,
fetchTrainsTermsValue} from '../../apiCall';
import { getDate, getHour, getCurrentTime, getFormatHour } from '../../common/utils';
import autoAnimate from '@formkit/auto-animate';
import InviteBack from './steps/invite-back';
import { calcPricePrivate, calcSadirPrice , newCalcPricePrivate } from '../../common/price-utils';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import TermsCard from '../termsCard/termsCard';


function CircularProgressWithLabel(props) {
    const theme = createTheme({
        typography: {
          fontSize: 50,
        },
      });
    return (
      <div>
        <CircularProgress/>
         {/* <Box sx={{ position: 'relative', display: 'inline-flex' }}> */}
        {/* <CircularProgress variant="determinate" {...props} size={200}/> */}
        {/* <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
        <ThemeProvider theme={theme}>
          <Typography variant="caption" component="div" color="text.secondary">
            {`${props.value}%`}
          </Typography>
          </ThemeProvider>
        </Box> */}
      {/* </Box> */}
      {/* <div>
      <img className='topBaner' src="topBaner.jpg" alt="logo-pych" />
      </div> */}
      </div>
    );
}



const Invite = (props) => {
    const [activeStep, setActiveStep] = useState(0);
    const [user, setUser] = useState({});
    const [disabled, setDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [approveCondition, setApproveCondition] = useState(false);
    const [isSuccessAlert, setIsSuccessAlert] = useState(false); 
    const [price, setPrice] = useState(0);
    const [dollarValue , setDollarValue] =useState(0);
    const [termsValue , setTermsValue] =useState('');
    const [trainsTermsValue , setTrainsTermsValue] =useState('');
    const [transactionId, setTransactionId] = useState("");
    const {state, dispatch} = useContext(Context);
    const resetState = () => dispatch({type:"RESET"});
    const setPrivateOrbitsDispatch = data => dispatch({type:"SET_PRIVATE_ORBITS", payload: data});
    const setSadirOrbitsDispatch = data => dispatch({type:"SET_SADIR_ORBITS", payload: data});
    const setPriceDispatch = data => dispatch({type:"SET_PRICE", payload: data});
    const setEmailDispatch = data => dispatch({type:"SET_EMAIL", payload: data});
    const setStopsDispatch = data => dispatch({type:"SET_STOPS", payload: data});
    const setCustomerSettingsDispatch = data => dispatch({type:"CUSTOMER_SETTINGS", payload: data});
    const setTrainsOrbitsDispatch = data => dispatch({type:"SET_TRAINS_ORBITS", payload: data});
    const set2025RangeDispatch = data => dispatch({type:"SET_RANGE_2025", payload: data});
    const setTermsValueDispatch = data => dispatch({type:"TERMS", payload: data});
    const setTrainsTermsValueDispatch = data => dispatch({type:"TRAINS_TERMS", payload: data});
     const setRecommendedHoursDispatch = data => dispatch({type:"SET_RECOMMENDED_HOURS", payload: data});
    const setStartLocationsDispatch = data => dispatch({type:"SET_START_LOCATIONS", payload: data});
    const addUserDispatch = (data) => dispatch({ type: "SET_USER", payload: data });
    const addLinkType = (data) => dispatch({ type: "SET_LINK_TYPE", payload: data });
    const setAgent =  (data) => dispatch({ type: "SET_AGENT", payload: data });
    const setCarTypesDispatch = data => dispatch({type:"SET_CAR_TYPES", payload: data});
    const setPriceBackDispatch = data => dispatch({type:"SET_PRICE_BACK", payload: data});
    const setApproveConditionDispatch = data => dispatch({ type: "SET_APROVE_CONDITION", payload: data });
    const setIsDialogOpenDispatch = data => dispatch({ type: "SET_IS_DAILOG_OPEN", payload: data });
    const setIdDispatch = data => dispatch({ type: "SET_ID", payload: data });
    const signatureRef = useRef(null);
    const canvas = signatureRef.current;
    const [isMenuOpen, setIsMenuOpen] = useState(true);
    const [isShowOkBtn, setIsShowOkBtn] = useState(true);
    const [showIframe, setShowIframe] = useState(false);
    const [loading, setLoading] = useState({privateOrbits: true, sadirOrbits: true, stops: true, startLocations: true, carTypes: true})
    const [loadPrivateOrbits, setLoadPrivateOrbits] = useState(true);
    const [loadSadirOrbits, setLoadSadirOrbits] = useState(true);
    const [loadStops, setLoadStops] = useState(true);
    const [loadStartLocation, setLoadStartLocation]= useState(true)
    const [loadCarTypes, setLoadCarTypes] = useState(true)
    const [isLoadingData, setIsLoadingData] = useState(true);
    const amountItemLoad = 5;
    const [progress, setProgress] = React.useState(10);
    const progressRef = useRef(null)
    const invitationRef = useRef(null)
    const [open, setOpen] = useState(false);
    const history = useHistory();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [signatureData, setSignatureData] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [IsSignatureAlert , setIsSignatureAlert] = useState(false);
    const [IsSignatureDeleteAlert , setIsSignatureDeleteAlert] = useState(false);
    const [isAgentsLink, setisAgentsLink] = useState(false);


    const getTripType= (customerSettings) => {
      if(!customerSettings){
        return;
      }
      // if only one trip type enable, go level 1
      let isTripPrivate = customerSettings.allowPrivateOrdering;
      let isTripSadir = customerSettings.allowSadirOrdering;
      let isTripTrain = customerSettings.allowTrainOrdering;
      let isTripRegularSadir = customerSettings.allowRegularSadirOrdering;

      // if only one selected trip type, set it and go to level 1
      const enabledTypes = [];
      if (isTripPrivate) enabledTypes.push(travelTypeEnum.private);
      if (isTripSadir) enabledTypes.push(travelTypeEnum.sadir);
      if (isTripTrain) enabledTypes.push(travelTypeEnum.train);
      if (isTripRegularSadir) enabledTypes.push(travelTypeEnum.regularSadir);

      if (enabledTypes.length === 1) {
        dispatch({ type: "SET_TRIP_TYPE", payload: enabledTypes[0] });
        if(enabledTypes[0] === travelTypeEnum.train){
          dispatch({ type: "SET_IS_TRAIN", payload: true })
        }
        setActiveStep(1);
      } else{
        setActiveStep(0);
      }
    }
    
    useEffect(() => {
        fetchData();
        get2025Range();
        getDollarValue();
        getCustomerSettings();
        getTrainsOrbits();
        getTermsValue();
        getTrainsTermsValue();
        getRecommendedHours();
        setUser(props.location.state);
        addUserDispatch(props.location.state);
        addLinkType(props.location.state.linkType); 
        setAgent(props.location.state.agent)
        setEmailDispatch(props.location.state.email)
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        setIsMenuOpen(!isMobile);      
        if (isSuccessAlert) {
            const timer = setTimeout(() => {
              setIsSuccessAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
          }  
    }, [isSuccessAlert]);

    // load for rosh hashanah only sadir orbits,
    //therefore not need this function
    /*useEffect(() => {
        // For loader
        let number = 0;
        if(!loadPrivateOrbits){
            number++;
        }
        if(!loadSadirOrbits){
            number++
        }
        if(!loadStops){
            number++
        }
        if(!loadStartLocation){
            number++
        }
        if(!loadCarTypes){
            number++;
        }
        setProgress(Math.round((number/amountItemLoad)*100))

        if(!loadPrivateOrbits && !loadSadirOrbits && !loadStops && !loadStartLocation && !loadCarTypes){
            setTimeout(()=>{
                setIsLoadingData(false)
            }, 500)
        }

    }, [loadPrivateOrbits, loadSadirOrbits, loadStops,loadStartLocation,
        loadCarTypes])
        */

    // For animation
    useEffect(() => {
        if (progressRef.current) {
          autoAnimate(progressRef.current);
        }
      }, [progressRef]);

      useEffect(() => {
        if (IsSignatureAlert) {
            const timer = setTimeout(() => {
                setIsSignatureAlert(false);
            }, 1000); 
            return () => clearTimeout(timer);
        }
    }, [IsSignatureAlert]);

    useEffect(() => {
        if (invitationRef.current) {
          autoAnimate(invitationRef.current);
        }
      }, [invitationRef]);

      useEffect(() => {
        console.log(state)
        if (props.location.state.linkType == 'Agents' || props.location.state.linkType == 'ByAgent') {

          setisAgentsLink(true)
        }
      }, [isAgentsLink]);


    const getSadirPrice= () =>{
        setPrice(calcSadirPrice(state.selectedOrbit, state.amount))
        setPriceDispatch(price)
    } ; 

    const getPrivatePrice= () =>{
        let result = calcPricePrivate(state.selectedOrbit, state.carType, state.amount); 
        console.log('getPrivatePrice11111', result)
        setPrice(result)
    } ; 
    const handleSignatureClear = () => {
        signatureRef.current?.clear();
        setSignatureData(null);
        setIsSignatureDeleteAlert(true)
      };
    
      const handleSaveSignature = () => {
        generateUniqueID()
        if (signatureRef.current && !signatureRef.current.isEmpty()) {
          setSignatureData(signatureRef.current.toDataURL());
          setIsSignatureAlert(true)
        }
      };


    const handleCheckboxChange = (event) => {
        setApproveCondition(event.target.checked);
        setApproveConditionDispatch(true)
      };

    const handleStepClick = (step) => {
        if(state.tripType === travelTypeEnum.private){
            getPrivatePrice();
        }else{
            getSadirPrice();  
        }
      setActiveStep(step);
    };

    const fetchData = () => {
        // not in use 
        getPrivateOrbits();
        getSadirOrbits();
        //getStops();
        //getStartLocations();
        getCarTypes();
    }

    const getPrivateOrbits = async() => {
        fetchOrbits('private', function(response){
            setPrivateOrbitsDispatch(response.result)  
            setLoadPrivateOrbits(false)
        });
    }

    const getSadirOrbits = () => {
      // if orbits exist in context, take them from context
      if (state.isLoadedSadirOrbits) {
        // not fetch orbits again
        setIsLoadingData(false)
        return;
      }

      fetchAllNewYearOrbits('sadir', function(response){
            // Filter orbits
            let orbits = filterSadirOrbits(response.result)
            setSadirOrbitsDispatch(orbits) 
            setLoadSadirOrbits(false)
            // If load all data, delete it and use useEffect at line 141
            setIsLoadingData(false)
        });
    }

    const filterSadirOrbits = (orbits) => {
        // filter what not display in customers
        // and freezed orbits
        // return orbits.filter(orbit => orbit.isShowInCustomers && !orbit.showSadirOrbit)
        return orbits.filter(orbit =>!orbit.showSadirOrbit)

    }

    const getStops = () => {
        fetchStopOptionsData(function(response){
            setStopsDispatch(response.result)   
            setLoadStops(false);
        });
    }

    const getStartLocations = () => {
            fetchStartLocationOptionsData(function(response){
                setStartLocationsDispatch(response.result);
                setLoadStartLocation(false);
            });
    }

    const getCarTypes = () => {
        fetchCarsOptionsData(function(response){
            setCarTypesDispatch(response.result) 
            setLoadCarTypes(false)
        });
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const getDollarValue = () => {
      fetchDollarValue(function(response) {
        console.log('getDollarValue', response.data.value)
          setDollarValue(response.data.value)
        if (!response.result || response == null) {
        } else {
        }
      });
    };

    const getCustomerSettings = () => {
      fetchCustomerSettings(function(response) {
        if (!response) {
          return;
        }
        // check tripType
        getTripType(response.data);
        setCustomerSettingsDispatch(response.data)
      });
    };

    const getTrainsOrbits = () => {
      fetchTrainsOrbits(function(response) {
        setTrainsOrbitsDispatch(response)
        if (!response || response == null) {
        } else {
        }
      });
    }

    const get2025Range = () => {
       fetchRange2025(function(response) {
          set2025RangeDispatch(response.data)
          console.log(state)
        if (!response || response == null) {
        } else {
        }
      });
    }

    const getTermsValue = () => {
      fetchTermsValue(function(response) {
          setTermsValue(response.data.termsOfUse)
          setTermsValueDispatch(response.data.termsOfUse)
        if (!response.result || response == null) {
        } else {
        }
      });
    };


     const getTrainsTermsValue = () => {
      fetchTrainsTermsValue(function(response) {
          setTrainsTermsValue(response.data.trainsTerms)
          setTrainsTermsValueDispatch(response.data.trainsTerms)
        if (!response.result || response == null) {
        } else {
        }
      });
    };

    const getRecommendedHours = () => {
      fetchAirportsAndHours(function(response) {
          setRecommendedHoursDispatch(response)
        if (!response || response == null) {
        } else {
        }
      });
    };

    const handleOrbitNext = () => {
        if(state.selectedOrbit && state.selectedOrbit.side === 'ka' && state.tripType === travelTypeEnum.private){
            setActiveStep((prevActiveStep) => prevActiveStep + 2);
        } else if(state.selectedOrbit && state.selectedOrbit.side === 'ka'){
            setActiveStep((prevActiveStep) => prevActiveStep + 3);
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
      };

    const handleNextPassengerDetails =() =>{
        if(state.tripType === travelTypeEnum.private){
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 2);
        }
    }

    const handleBackSummary = () =>{
        if(state.tripType === travelTypeEnum.private){
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep - 2);
        }
    }

    const handleSummaryButtonClick = () => {
        console.log(state)
        setActiveStep(1);
        setTimeout(() => {
            setActiveStep(7);
          }, 100);
      };

    const handleDateBack = () => {
        if(state.tripType === travelTypeEnum.private){
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep - 2);
        }
    }
    const handleSaveTravel = () => {
        setIsLoading(true);
        setDisabled(true)
        const invitationData = { data: createInvitation() };
        localStorage.setItem('invitationData', JSON.stringify(invitationData));
        fetchSaveTravel(invitationData)
          .then(() => {
            setDisabled(false)
            setIsLoading(false);
            setIsSuccessAlert(true)
            reset();
            setActiveStep(0);
          })
          .catch(() => {
            setDisabled(false)
            setIsLoading(false); 
            alert('שגיאה. הזמנתך לא נקלטה.');
          });
      };

    const reset = () => {
        resetState();
    }
    const handlePaymentDetails = () => {
      setIsShowOkBtn(false);
      setIsLoading(true);
      if(dollarValue == 0 || dollarValue === null || dollarValue === undefined || dollarValue === '' || !dollarValue){
        dollarValue = 3.4600 ; 
      }

      const multiplier = state.currency === 1 ? dollarValue : 1;
      console.log(state.pricePercent ,  state.priceBackPercent , state.currency)
        fetchPaymentDetails((data) => {
        if (data.URL) {
          const searchParams = new URLSearchParams(new URL(data.URL).search);
          const transactionIdUrl = searchParams.get('transactionId');
          setTransactionId(transactionIdUrl);
          const invitationData = { data: createInvitation(transactionIdUrl) };
          console.log(invitationData)
          localStorage.setItem('invitationData', JSON.stringify(invitationData));
          setShowIframe(true);
          const iframe = document.getElementById('iframeContainer');
          iframe.src = data.URL;
          iframe.setAttribute('allow', 'payment allow-top-navigation');
    
          setTimeout(() => {
            console.log(localStorage);
            console.log(localStorage.getItem('invitationData'));
          }, 1000);
        }
        setIsLoading(false);
      }, (state.pricePercent + state.priceBackPercent) * multiplier, state.user.email, state.id , state.currency , state.phone , state.maxPayments , state.minPayments , state.tripType , state.customerSettings , state);
    };

    const createTravelBack = (transactionIdUrl) =>{
      const multiplier = state.currency === 1 ? dollarValue : 1;
      let invitation = {
      localID: state.id,
      terms: state.terms,
      customerDetails : user ,
      travelType: state.tripType === travelTypeEnum.private? travelTypeAdminEnum.private: travelTypeAdminEnum.sadir,
      date: getDate(state.dateBack),
      time: state.tripType === travelTypeEnum.private? getHour(state.hourBack):
       getFormatHour(state.selectedOrbitBack.hour + ':' + state.selectedOrbitBack.minutes),
      orbit: state.selectedOrbitBack,
      name: state.name,
      englishName : state.englishName , 
      flightNumber : state.flightNumber , 
      phonNumber: state.countryCode +  state.phone,
      amount: state.amount,
      phone: state.countryCode +  state.phone,
      anotherPhone : state.secondCountryCode + state.anotherPhone , 
      notes: state.notes,
      mail: user.email,
      carId : state.carType.id , 
      car : state.carType , 
      price : state.priceBack ,
      signature : signatureData , 
      linkType : props.location.state.linkType  , 
      approveCondition : approveCondition , 
      paymentTransactionId : transactionIdUrl , 
      dollarValue : dollarValue ,
      priceBackPercent : state.priceBackPercent * multiplier , 
      orderTime: getCurrentTime() ,
      }
      if(state.currency === 1 ){
        invitation.currency = 'NIS' 
      }else{
        invitation.currency=  'Dollar' 
      }
      if(state.linkType === 'Agents' || state.linkType === 'ByAgent'){
        invitation.agent = state.agent
      }
      return invitation ; 
    }
    

    const createInvitation = (transactionIdUrl) => {
      const multiplier = state.currency === 1 ? dollarValue : 1;
      state.privateOrbits = [];
      state.sadirOrbits = [];
      state.customerSettings.selectedRegistrationWorkers = [] ;
      state.range2025 = [] ;
      state.carTypes = [];
      state.recommendedHours = [] ;
      state.trainsOrbits = [] ; 
      state.customerSettings.comissionProcents = [] ;
      state.trainsTerms  = '' ; 
        let invitation = {
             originData: {
    ...state,
    terms: ' ' , 
    trainsTerms : ' ' ,
    agent : {}
  },
            localID: state.id,
            terms: state.terms,
            trainsTerms: state.trainsTerms , 
            customerDetails : user ,
            travelType: state.tripType === travelTypeEnum.private? travelTypeAdminEnum.private: travelTypeAdminEnum.sadir,
            // date: getDate(state.date),
            time: state.tripType === travelTypeEnum.private? getHour(state.hour || state.hourBack):
             getFormatHour(state.selectedOrbit.hour + ':' + state.selectedOrbit.minutes),
            orbit: state.selectedOrbit,
            name: state.name,
            englishName : state.englishName , 
            flightNumber : state.flightNumber , 
            phonNumber: state.countryCode +  state.phone,
            amount: state.amount,
            phone: state.countryCode +  state.phone,
            anotherPhone : state.secondCountryCode + state.anotherPhone , 
            notes: state.notes,
            mail: user.email,
            isTrain : state.isTrain ,
            carId : state.carType.id , 
            car : state.carType , 
            price : state.price , 
            //price :  state.currency === 1 ? state.price + 1.5 : state.price + 0.45 , 
            signature : signatureData , 
            linkType : props.location.state.linkType  , 
            approveCondition : approveCondition , 
            paymentTransactionId : transactionIdUrl , 
            dollarValue : dollarValue , 
            //pricePercent : state.pricePercent * multiplier , 
            pricePercent : state.currency === 1 ? state.pricePercent  * multiplier + 1.5 : state.pricePercent  * multiplier + 0.45, 
            orderTime: getCurrentTime()}
            if(state.selectedOrbitBack ){
              invitation.travelBack=  createTravelBack(transactionIdUrl) 
            }
            if(state.currency === 1 ){
              invitation.currency = 'NIS' 
            }else{
              invitation.currency=  'Dollar' 
            }
            if(state.side === 'מאומן'){
              invitation.date = getDate(state.dateBack)
            }else{
              invitation.date = getDate(state.date)
            }
          if(state.linkType === 'Agents' || state.linkType === 'ByAgent'){
            invitation.agent = state.agent ; 
          }
        if(state.tripType === travelTypeEnum.private) {
            invitation.carId = state.carType.id;
            invitation.car  = state.carType ; 
            let stops = []
            if(state.tripStops.length > 0) {
                stops.push({'trip': [...state.tripStops]});
            }
            if(state.saturdayStops.length > 0) {
                stops.push({'saturday': [...state.saturdayStops]});
            }
            if(state.sleepStops.length > 0) {
                stops.push({'sleep': [...state.sleepStops]});
            }
            invitation.stops = stops;
        }

        if(state.side === sideEnum.fromUman){
        }
        invitation.orbit.startLocation = "true" ;
        invitation.orbit.hebrewAdress = state.selectedOrbit.name ; 
        invitation.startLocationId = state.startLocation ; 
        invitation.terms = state.terms ;
        invitation.isCustomerApproved = false ; 
        console.log("create invitation",invitation)
        return invitation;
    }


    const updateOrientation = () => {
         setIsMobile(window.innerWidth <= 768);
        //setIsMobile(true);
      };
    
      useEffect(() => {
        window.addEventListener('resize', updateOrientation);
            return () => {
          window.removeEventListener('resize', updateOrientation);
        };
      }, []);

      const handleNext = () => {
        if(activeStep === 1 && state.side === 'מאומן'){
          setActiveStep(2)  
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setPrice(calcSadirPrice(state.selectedOrbit, state.amount))
        setPriceDispatch(calcSadirPrice(state.selectedOrbit, state.amount))
        const priceBack = calcSadirPrice(state.selectedOrbitBack, state.amount);
        setPriceBackDispatch(priceBack);
        if(state.tripType === travelTypeEnum.private){
          setPrice(newCalcPricePrivate(state.selectedOrbit, state.carType, state.amount))
          setPriceDispatch(newCalcPricePrivate(state.selectedOrbit, state.carType, state.amount))
          const priceBack = newCalcPricePrivate(state.selectedOrbitBack, state.carBackType , state.amount);
        setPriceBackDispatch(priceBack);
        }
        console.log('handleNext' , state)
      };

      const handleBackMobile = () => {
        if(activeStep === 3 && state.side === 'מאומן'){
          setActiveStep(2)  
        }
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      };

        const generateUniqueID = () => {
            const randomNumber = Math.floor(100000 + Math.random() * 900000); 
            setIdDispatch(`RH${randomNumber}`)
            return `RH${randomNumber}`;
        };
    
      const handleClick = () => {
        setOpenDialog(true);
        setIsDialogOpenDispatch(true); 
      };
    
      const handleClose = () => {
        setOpenDialog(false);
      };
    


    const handleStepSummary = () => {
        handleStepClick(8)
        // calculate price invite back
        let priceBack = 0;
        if(state.tripType === travelTypeEnum.private){
            priceBack = calcPricePrivate(state.selectedOrbitBack, state.carType, state.amount)
        } else {
            priceBack = calcSadirPrice(state.selectedOrbitBack, state.amount);
        }
        setPriceBackDispatch(priceBack);
    }

    return (
        <div>
            <div>
                <SideBar></SideBar>
                <TopBaner></TopBaner>
                {isAgentsLink && (
               <div style={{ textAlign: 'center' }}>
               {/* <h6>סוכן:{state.agent.firstName}</h6> */}
                </div>
               )}
                    <Box className='inviteContent'>
                        <div className='titlesDiv'>
                            {isSuccessAlert && (
                                <Alert style={{ position: 'fixed', top: 200, right: 0, textAlign: 'right', margin: '20px' }} onClose={() => { setIsSuccessAlert(false) }}>הנסיעה הוזמנה בהצלחה</Alert>
                            )}
                             {IsSignatureAlert && (
                                <Alert style={{ position: 'fixed', top: 200, right: 0, textAlign: 'right', margin: '20px' }} onClose={() => { setIsSignatureAlert(false) }}>החתימה נשמרה</Alert>
                            )}
                              {IsSignatureDeleteAlert && (
                                <Alert style={{ position: 'fixed', top: 200, right: 0, textAlign: 'right', margin: '20px' }} onClose={() => { setIsSignatureDeleteAlert(false) }}>החתימה נמחקה</Alert>
                            )}
                        </div>
                        {isLoading && (
                            <div style={{ position: 'relative' }}>
                                <div
                                    style={{
                                        position: 'fixed',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 9999,
                                        padding: '20px',
                                        borderRadius: '8px',
                                    }}
                                >
                                    <CircularProgress sx={{ color: '#3422F2' }} size={200} />
                                </div>
                            </div>
                        )}
                        {isLoadingData ?
                            <div style={{ 'textAlign': 'center' }} ref={progressRef}>
                                <CircularProgressWithLabel value={progress} />
                            </div> :
                            <div className='stepperDiv' style={{ display: 'flex', justifyContent: 'start'  , position : 'static'}}>
                                <CardContent style={{ margin: '0 auto' }}>
                                    {isMobile ? (
        <div>
          {activeStep === 0 && <div>
             <TravelType></TravelType>
            {state.tripType ? 
            <button className='nextBtn' onClick={handleNext} style={{ marginLeft: '0px' }}>
                הבא
                <span style={{ marginLeft: '5px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
                <ArrowForwardIosIcon  style={{ color: 'black' , fontSize:'20px' , marginBottom:'3px'}}/>
                </span>
                </button>
                    :
                    
                     <h5>לקוחות יקרים ההרשמה סגורה כעת</h5>
}
            {/* <div className='card homeCard' style={{backgroundColor:'#fff200' , marginTop:'0px' ,height:'350px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <p style={{fontWeight: 'bold' , textAlign:'center' , fontSize:'22px'}}>אנו שמחים ללוות אותך במסע שלך לקברי צדיקים אירופה</p>
                
            </div> */}
            
            </div>}
          {activeStep === 1 && <div>
            <h5> בחר תאריך ומסלול נסיעה </h5>
            {state.side === 'מאומן' ? <><DateHour isInviteBack={true}></DateHour></> : <> <DateHour ></DateHour></>}
            {state.tripType === travelTypeEnum.private ?<CarType isInviteBack={false}></CarType>: <></>}
            <Orbit></Orbit>
            </div>}
          {activeStep === 2 && <div>
            {state.side === sideEnum.toUman ?
            (
            <div>
         <h5>  (אופציונלי)הזמנת חזור</h5>
         {/* <h6>10$ שים לב - בהזמנת חזור תקבל הנחה </h6> */}
         {/* {state.side === 'מאומן' ? <>הלאה</> : <><InviteBack></InviteBack></>} */}
         <InviteBack></InviteBack>
            </div>
             )
            : <></>}
            </div>}
          {activeStep === 3 && <div>
            <h5>
             הזן את פרטיך ומס' הנוסעים המבוקש
            </h5>
            <PassengerDetails></PassengerDetails>
            <Notes></Notes>
            </div>}
          {activeStep === 4 && <div>
            &nbsp;
            <Email email={user.email}></Email>
            &nbsp;
            <div className='signatureInput signatureInputMobile'>
            <p style={{ textAlign: 'center', marginTop: '7px' }}>נא לחתום כאן *</p>
            {signatureData ? (
              <img
                src={signatureData}
                alt='Signature'
                style={{ width: 250, height: 100 }}
              />
            ) : (
              <SignatureCanvas
                ref={signatureRef}
                canvasProps={{ width: 250, height: 100 }}
              />
            )}  
            <button style={{marginLeft:'50px'}} className='backBtn' onClick={handleSignatureClear}>נקה</button>
            <button className='nextBtn' style={{marginLeft:'15px'}} onClick={handleSaveSignature}>שמור</button>
          </div>
        
          <div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox checked={state.approveCondition} onChange={handleCheckboxChange} />
            <span
        style={{ fontWeight: 'bold', marginRight: '5px', color: '#3422F2', cursor: 'pointer' }}
        onClick={handleClick}
      >
        לצפיה בתקנון לחץ כאן
      </span>
      <Dialog open={openDialog && state.isDialogOpen} onClose={handleClose}>
        <DialogTitle>
        <TermsCard></TermsCard>
        </DialogTitle>
        <DialogContent>
          </DialogContent>
      </Dialog>               
                <span style={{ fontWeight: 'bold', marginRight: '5px'  , textAlign:'center'}}>
                בחתימתי הנני מאשר\ת את תנאי ההזמנה לרבות תנאי הביטול כמפורט בתנאי ההזמנה.</span>
             </div>
             <div>
            </div>
            <Summary price={price} handleSummaryButtonClick={handleSummaryButtonClick} activeStep={activeStep}  setActiveStep={setActiveStep} isMobile={isMobile} ></Summary>
             <div>
            {showIframe && (
            <div id="iframeDiv"  style={{ backgroundColor: '#f8f8ff', display: 'flex', justifyContent: 'center'}} >
            <iframe style={{ width: '450px', marginTop: '20px', borderRadius: '10px' }} id="iframeContainer"></iframe>
            </div>
            )}
            </div>
            <Box sx={{ mb: 2 }}>
            <div>
            {state.tripType === travelTypeEnum.private ?
            <button
            className='optionsBtn'
            variant="contained"
            onClick={handlePaymentDetails}
            sx={{ mt: 1, mr: 1 }}
            disabled={disabled || !state.name || !state.englishName || !state.selectedOrbit || !state.carType || !state.date || !state.phone || !signatureData|| !approveCondition}
            >
            אישור
            </button>
             :
           <div>
              {isShowOkBtn ? 
            <button
            className='optionsBtn'
            variant="contained"
            // onClick={handlePaymentDetails}
            onClick={() => {
                if (!state.name) {
                  alert('חובה לציין שם בעברית');
                  setActiveStep(3)
                } 
                // else 
                //   if (!state.englishName) {
                //   alert('חובה לציין שם באנגלית');
                //   setActiveStep(3)
                // }
                else if (state.amount < 1) {
                  alert('מנימום אחד');
                  setActiveStep(3)
                } else if (!state.selectedOrbit) {
                  alert('חובה לבחור מסלול');
                  setActiveStep(1)
                } 
                else if (state.tripType === travelTypeEnum.private && !state.carType) {
                  alert('חובה לבחור סוג רכב');
                  setActiveStep(1)
                }
                else if (state.tripType === travelTypeEnum.private && !state.carBackType && state.selectedOrbitBack) {
                  alert('חובה לבחור סוג רכב');
                  setActiveStep(1)
                }
                 else if (state.tripType === travelTypeEnum.private && !state.hourBack && state.selectedOrbitBack) {
                  alert('חובה לבחור שעה');
                  setActiveStep(1)
                }
                else if (state.tripType === travelTypeEnum.private && state.side == 'לאומן' && !state.hour) {
                  alert('חובה לבחור שעה');
                  setActiveStep(1)
                }
                // else if (!state.date) {
                //   alert('חובה לבחור תאריך');
                //   setActiveStep(1)
                // }
                 else if (!state.phone || state.phone.length < 7) {
                  alert('חובה לציין מספר טלפון תקין');
                  setActiveStep(3)
                } else if (!state.flightNumber && state.side === 'לאומן') {
                    alert('חובה לציין מספר טיסה')
                    setActiveStep(3)
                } else if ((signatureData === null) && !signatureRef.current.isEmpty() ) {
                  alert('חובה לשמור חתימה');
                }else if (!signatureData) {
                  alert('חובה לספק חתימה');
                } 
                else if (!state.approveCondition) {
                  alert('חובה לאשר את תנאי השימוש');
                } else {
                  handlePaymentDetails();
                }
              }}
            sx={{ mt: 1, mr: 1 }}
            // disabled={disabled || !state.name || !state.englishName || !state.selectedOrbit || !state.date || !state.phone || !signatureData  || !approveCondition}
            >
                סיום ומעבר לתשלום
            </button>  
              : null}
             </div>                                                
            }
            </div>
             </Box>
            </div>}
            {activeStep > 0  && (
            <button className='backBtn' onClick={handleBackMobile}>
            הקודם
           <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
           <ArrowBackIosNewIcon  style={{ color: '#737373' , fontSize:'20px' , marginBottom:'3px'}}/>
           </span>
           </button>
          )}
           {activeStep === 2 && !state.selectedOrbitBack ? <>
            <button className='nextBtn' onClick={handleNext}>
            דלג
                <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
                <ArrowForwardIosIcon  style={{ color: '#275d5f' , fontSize:'20px' , marginBottom:'3px'}}/>
                </span>
                </button>
           </> : <></>}
           {activeStep === 2 && state.selectedOrbitBack ? <>
            <button className='nextBtn' onClick={handleNext}>
            הבא
                <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
                <ArrowForwardIosIcon  style={{ color: '#275d5f' , fontSize:'20px' , marginBottom:'3px'}}/>
                </span>
                </button>
           </> : <></>}
           {activeStep < 4  && activeStep != 0 && activeStep != 2 && activeStep != 1 && activeStep != 3  ? (            
           <button className='nextBtn' onClick={handleNext}>
            הבא
                <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
                <ArrowForwardIosIcon  style={{ color: '#275d5f' , fontSize:'20px' , marginBottom:'3px'}}/>
                </span>
                </button>
          ) : (
        <></> )}
       {activeStep === 1 ? (
        <button className='nextBtn' onClick={() => {
          if (!state.selectedOrbit) {
            alert('חובה לבחור מסלול');
          }else if (state.tripType === travelTypeEnum.private && !state.carType) {
                  alert('חובה לבחור סוג רכב');
          }else if (state.tripType === travelTypeEnum.private && state.side == 'לאומן' && !state.hour) {
                  alert('חובה לבחור שעה');
          }
          else if (state.tripType === travelTypeEnum.private && !state.carBackType && state.selectedOrbitBack) {
                  alert('חובה לבחור סוג רכב');
                }
                 else if (state.tripType === travelTypeEnum.private && !state.hourBack && state.selectedOrbitBack) {
                  alert('חובה לבחור שעה');
                }
          else{
            handleNext()
          }
      }}>
      הבא
      <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
      <ArrowForwardIosIcon  style={{ color: '#275d5f' , fontSize:'20px' , marginBottom:'3px'}}/>
      </span>
      </button>
      ) : (
    <></> )}

{activeStep === 3 ? (
        <button className='nextBtn' onClick={() => {
          if (!state.name) {
            alert('חובה לציין שם בעברית');
          } 
          // else if (!state.englishName) {
          //   alert('חובה לציין שם באנגלית');
          // }
          else if (state.amount < 1) {
            alert('מנימום אחד');
          }  else if (!state.phone || state.phone.length < 7) {
            alert('חובה לציין מספר טלפון תקין');
          }else if (!state.flightNumber && state.side === 'לאומן') {
            alert('חובה לציין מספר טיסה')
          }else{
            handleNext()
          }
      }}>
      הבא
      <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
      <ArrowForwardIosIcon  style={{ color: '#275d5f' , fontSize:'20px' , marginBottom:'3px'}}/>
      </span>
      </button>
      ) : (
    <></> )}
        </div>
      ) : (
      <div>
      {activeStep === 0 && <div>
        <TravelType></TravelType>
        {state.tripType ? 
        <button className='nextBtn' onClick={handleNext} style={{marginLeft:'0px'}}>הבא6 {state.tripType}<ArrowForwardIosIcon></ArrowForwardIosIcon>  </button>
        :<h5>לקוחות יקרים ההרשמה סגורה כעת</h5>
        }
        {/* <div className='card homeCard' style={{backgroundColor:'#fff200' , marginTop:'0px' ,height:'350px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <p style={{fontWeight: 'bold' , textAlign:'center' , fontSize:'22px'}}>אנו שמחים ללוות אותך במסע שלך לקברי צדיקים אירופה</p>
        </div> */}
        </div>}
      {activeStep === 1 && <div>
        {/* <h5 style={{color:'red'}}>שימו לב מסוף טסטים</h5> */}
        <h5>הזמנת נסיעה {state.tripType}</h5>
        <h5>   בחר תאריך ומסלול נסיעה </h5>
        {/* <DateHour></DateHour> */}
        {state.side === 'מאומן' ? <><DateHour isInviteBack={true}></DateHour></> : <> <DateHour ></DateHour></>}
        
                {state.tripType === travelTypeEnum.private ?<CarType isInviteBack={false}></CarType>: <></>}
<Orbit></Orbit>
        
        </div>}
      {activeStep === 2 && <div>
        {state.side === sideEnum.toUman ?
        (
        <div>
         <h5>  (אופציונלי)הזמנת חזור</h5>
         {/* <h6 style={{textAlign :'center'}}>10$ שים לב - בהזמנת הלוך ושוב תקבל הנחה </h6> */}
        <InviteBack></InviteBack>
        </div>
         )
        : <></>}
        </div>}
      {activeStep === 3 && <div>
        <h5>
        הזן את פרטיך ומס' הנוסעים המבוקש
        </h5>
        <PassengerDetails></PassengerDetails>
        <Notes></Notes>
        </div>}
      {activeStep === 4 && <div>
        &nbsp;
        <Email email={user.email}></Email>
        &nbsp;
        <div className='signatureInput signatureInputMobile'>
        <p style={{ textAlign: 'center', marginTop: '7px' }}>נא לחתום כאן *</p>
        {signatureData ? (
          <img
            src={signatureData}
            alt='Signature'
            style={{ width: 390, height: 100 }}
          />
        ) : (
          <SignatureCanvas
            ref={signatureRef}
            canvasProps={{ width: 390, height: 100 }}
          />
        )}  
        <button style={{marginLeft:'50px'}} className='backBtn' onClick={handleSignatureClear}>נקה</button>
        <button className='nextBtn' style={{marginLeft:'15px'}} onClick={handleSaveSignature}>שמור</button>
      </div>
    
      <div>
        </div>
        <div>
          <p style={{ fontWeight: 'bold', textAlign:'center'}}>
            בחתימתי הנני מאשר\ת את תנאי ההזמנה </p> 
            <p style={{ fontWeight: 'bold', textAlign:'center'}}>
            <Checkbox checked={state.approveCondition} onChange={handleCheckboxChange} />
            לרבות תנאי הביטול כמפורט בתנאי ההזמנה
            </p> 
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
        <span
    style={{ fontWeight: 'bold', color: '#3422F2', cursor: 'pointer' , marginLeft: '150px'  }}
    onClick={handleClick}
  >
    לצפיה בתקנון לחץ כאן
  </span>
  <Dialog open={openDialog && state.isDialogOpen} onClose={handleClose}>
    <DialogTitle>
    <TermsCard></TermsCard>
    </DialogTitle>
    <DialogContent>
      </DialogContent>
  </Dialog> 
         </div>
         <div>
        </div>
        <Summary price={price} handleSummaryButtonClick={handleSummaryButtonClick} activeStep={activeStep}  setActiveStep={setActiveStep} isMobile={isMobile} ></Summary>
         <div>
        {showIframe && (
        <div id="iframeDiv"  style={{ backgroundColor: '#f8f8ff', display: 'flex', justifyContent: 'center'}} >
        <iframe style={{ width: '450px', marginTop: '20px', borderRadius: '10px' }} id="iframeContainer"></iframe>
        </div>
        )}
        </div>
        <Box sx={{ mb: 2 }}>
        <div>
        {state.tripType === travelTypeEnum.private ?
        <button
        className='optionsBtn'
        variant="contained"
        onClick={handlePaymentDetails}
        sx={{ mt: 1, mr: 1 }}
        disabled={disabled || !state.name || !state.englishName || !state.selectedOrbit || !state.carType || !state.date || !state.phone || !signatureData|| !approveCondition}
        >
        אישור
        </button>
         :
       <div>
          {isShowOkBtn ? 
        <button
        className='optionsBtn'
        variant="contained"
        onClick={() => {
            if (!state.name) {
              alert('חובה לציין שם בעברית');
              setActiveStep(3)
            } 
            // else if (!state.englishName) {
            //   alert('חובה לציין שם באנגלית');
            //   setActiveStep(3)
            // }
            else if (state.amount < 1) {
              alert('מנימום אחד');
              setActiveStep(3)
            } 
             else if (!state.selectedOrbit) {
              alert('חובה לבחור מסלול');
              setActiveStep(1)
            }
            else if (state.tripType === travelTypeEnum.private && !state.carType) {
                  alert('חובה לבחור סוג רכב');
                  setActiveStep(1)
                }
            else if (state.tripType === travelTypeEnum.private && state.side == 'לאומן' && !state.hour) {
                  alert('חובה לבחור שעה');
                  setActiveStep(1)
                }
            else if (state.tripType === travelTypeEnum.private && !state.carBackType && state.selectedOrbitBack) {
                  alert('חובה לבחור סוג רכב');
                  setActiveStep(1)
                }
                 else if (state.tripType === travelTypeEnum.private && !state.hourBack && state.selectedOrbitBack) {
                  alert('חובה לבחור שעה');
                  setActiveStep(1)
                }
            // else if (!state.date) {
            //   alert('חובה לבחור תאריך');
            //   setActiveStep(1)
            // }
             else if (!state.phone || state.phone.length < 7) {
              alert('חובה לציין מספר טלפון תקין');
              setActiveStep(3)
            } else if (!state.flightNumber && state.side === 'לאומן') {
                alert('חובה לציין מספר טיסה')
                setActiveStep(3)
            }else if ((signatureData === null) && !signatureRef.current.isEmpty() ) {
              alert('חובה לשמור חתימה');
            }else if (!signatureData) {
              alert('חובה לספק חתימה');
            } else if (!state.approveCondition) {
              alert('חובה לאשר את תנאי השימוש');
            } else {
              handlePaymentDetails();
            }
          }}
        sx={{ mt: 1, mr: 1 }}
        // disabled={disabled || !state.name || !state.englishName || !state.selectedOrbit || !state.date || !state.phone || !signatureData  || !approveCondition}
        >
            סיום ומעבר לתשלום
        </button>  
          : null}
         </div>                                                
        }
        </div>
         </Box>
        </div>}
        {activeStep > 0  && (
       <button className='backBtn' onClick={handleBackMobile}>
       הקודם
        <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
        <ArrowBackIosNewIcon  style={{ color: '#737373' , fontSize:'20px' , marginBottom:'3px'}}/>
        </span>
        </button>
      )}
      {activeStep === 2 && !state.selectedOrbitBack ? <>
            <button className='nextBtn' onClick={handleNext}>
            דלג
                <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
                <ArrowForwardIosIcon  style={{ color: '#275d5f' , fontSize:'20px' , marginBottom:'3px'}}/>
                </span>
                </button>
           </> : <></>}
           {activeStep === 2 && state.selectedOrbitBack ? <>
            <button className='nextBtn' onClick={handleNext}>
            הבא
                <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
                <ArrowForwardIosIcon  style={{ color: '#275d5f' , fontSize:'20px' , marginBottom:'3px'}}/>
                </span>
                </button>
           </> : <></>}
      {activeStep < 4  && activeStep != 0 && activeStep != 2 && activeStep != 1 && activeStep != 3  ? (
        <button className='nextBtn' onClick={handleNext}>
            הבא
                <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
                <ArrowForwardIosIcon  style={{ color: '#275d5f' , fontSize:'20px' , marginBottom:'3px'}}/>
                </span>
                </button>
      ) : (
    <></> )}

     {activeStep === 1 ? (
        <button className='nextBtn' onClick={() => {
          if (!state.selectedOrbit) {
            alert('חובה לבחור מסלול');
          }else if (state.tripType === travelTypeEnum.private && !state.carType) {
                  alert('חובה לבחור סוג רכב');
          }
          else if (state.tripType === travelTypeEnum.private && state.side == 'לאומן' && !state.hour) {
                  alert('חובה לבחור שעה');
         }
         else if (state.tripType === travelTypeEnum.private && !state.carBackType && state.selectedOrbitBack) {
                  alert('חובה לבחור סוג רכב');
                }
                 else if (state.tripType === travelTypeEnum.private && !state.hourBack && state.selectedOrbitBack) {
                  alert('חובה לבחור שעה');
                }
                else{
            handleNext()
          }
      }}>
      הבא
      <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
      <ArrowForwardIosIcon  style={{ color: '#275d5f' , fontSize:'20px' , marginBottom:'3px'}}/>
      </span>
      </button>
      ) : (
    <></> )}

{activeStep === 3 ? (
        <button className='nextBtn' onClick={() => {
          if (!state.name) {
            alert('חובה לציין שם בעברית');
          } 
          // else if (!state.englishName) {
          //   alert('חובה לציין שם באנגלית');
          // } 
          else if (!state.phone || state.phone.length < 7) {
            alert('חובה לציין מספר טלפון תקין');
          }else if (state.amount < 1) {
            alert('מנימום אחד');
          } 
          else if (!state.flightNumber && state.side === 'לאומן') {
            alert('חובה לציין מספר טיסה')
          }else{
            handleNext()
          }
      }}>
      הבא
      <span style={{ marginLeft: '12px' , backgroundColor: '#ffff' ,  borderRadius:'50px' , padding:'1px'}}>
      <ArrowForwardIosIcon  style={{ color: '#275d5f' , fontSize:'20px' , marginBottom:'3px'}}/>
      </span>
      </button>
      ) : (
    <></> )}

    </div>

      )}
                                  
      </CardContent>
                            </div>
                        }
                    </Box>
                </div>
                <div className='footerDiv'>
                 <Footer></Footer>    
                </div>
           
        </div>
    )

}

export default Invite;

